var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDdImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.375C18.3125 7.5 18.625 8.5 18.0312 9.09375L14.75 12.3125L15.5312 16.8438C15.6562 17.6562 14.7812 18.2812 14.0625 17.9062L10 15.75L5.90625 17.9062C5.1875 18.2812 4.3125 17.6562 4.4375 16.8438L5.21875 12.3125L1.9375 9.09375C1.34375 8.5 1.65625 7.5 2.46875 7.375L7.0625 6.71875L9.09375 2.5625C9.46875 1.8125 10.5312 1.84375 10.875 2.5625L12.9375 6.71875L17.5 7.375ZM13.6562 11.9375L17.3438 8.375L12.25 7.625L10 3L7.71875 7.625L2.625 8.375L6.3125 11.9375L5.4375 17L10 14.625L14.5312 17L13.6562 11.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDdImg2);
export default __webpack_public_path__ + "static/media/profileDDImg2.f76f482e0b361efbdc647faff3b13bab.svg";
export { ForwardRef as ReactComponent };